export default "__VITE_PUBLIC_ASSET__7421e82c__"